import { useLocation, useNavigate } from 'react-router-dom';

import { maps } from './map-switch.options';
import './map-switch.styl';

function MapSwitch() {
  const navigate = useNavigate();
  const location = useLocation();
  const lastSegment = location.pathname.split('/').filter(Boolean).pop();

  return (
    <div className="map-switch">
      {maps.map(({ title, image, path }) => {
        return (
          <div 
            className={`map-switch__option${`/${lastSegment}` === path ? ' map-switch__option--active' : ''}`}
            onClick={() => navigate(path)}
            key={title}
          >
            <img 
              className="map-switch__option__image"
              src={`/img/maps/${image}`}
            />
            <span className="map-switch__option__title">
              {title}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default MapSwitch;